import { AuthFlow } from '@griply/types';
import { applyActionCode } from 'firebase/auth';

import { getAuthentication, handleAuthError } from './helpers';

export const verifyEmail = async (actionCode: string) => {
  const auth = await getAuthentication();

  try {
    await applyActionCode(auth, actionCode);
  } catch (e) {
    throw handleAuthError(e, AuthFlow.VerifyEmail);
  }
};
